import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import CommandControlContent from '../components/CommandControl/CommandControlContent/CommandControlContent'
import CommandControlHero from '../components/CommandControl/CommandControlHero/CommandControlHero'

const CommandControl = ({ data }) => {
  const postNode = {
    title: `Command and Control - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="command-control" customTitle />
      <Helmet>
        <title>{`Command and Control - ${config.siteTitle}`}</title>
      </Helmet>
      <CommandControlHero />
      <CommandControlContent />
    </Layout>
  )
}

export default CommandControl
